import { useActiveBanners } from "@/hooks/useBanners";
import { Hero } from "./Hero";

export const HeroBanner = () => {
  const { data: banners, isLoading } = useActiveBanners();

  return (
    <Hero
      banners={banners && banners.length > 0 ? banners : undefined}
      bannersLoading={isLoading}
    />
  );
};
